/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const digipass_corporate_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={26}
    fill="none"
    viewBox="0 0 24 26"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M3.089 9.383c-.498 7.52.917 15.367 8.943 15.367s9.408-7.846 8.863-15.367m-17.806 0c.1-1.523.327-5.13.55-6.87a.887.887 0 0 1 .632-.743C5.695 1.35 8.57.75 12.032.75c3.456 0 6.26.599 7.637 1.018a.883.883 0 0 1 .62.731c.23 1.69.482 5.164.597 6.756l.01.128m-17.807 0c1.19.302 4.788.907 9.035.907 4.248 0 7.617-.605 8.771-.907M9.002 5.75h6"
    />
  </svg>
)
export default digipass_corporate_medium
